import React from 'react'

const PageNotFound = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height:'100vh'}}>
            <h1>... Page Not found ... </h1>
        </div >
    )
}

export default PageNotFound